<h1 class="page-title w-50">الاخبار
</h1>
<div class="mb-5" *ngIf="newsItem">
    <div class="container">
        <div class="d-flex justify-content-between">
            <div class="share-section mb-4 w-50 pt-5">
                <div class="share-text mb-2">شارك المقال على</div>
                <div class="social-icons d-flex justify-content-end gap-2">
                    <a href="#" class="social-icon">
                        <i class="fa-brands fa-twitter"></i>
                    </a>
                    <a href="#" class="social-icon">
                        <i class="fa-brands fa-facebook-f"></i>
                    </a>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-4">
                <div class="image-wrapper">
                    <img [src]="newsItem.image" [alt]="newsItem.title" class="img-fluid rounded-start">
                </div>
            </div>
            <div class="col-lg-8">
                <div class="news-date mb-2">{{ newsItem.date }}</div>
                <h1 class="news-title mb-4">{{ newsItem.title }}</h1>

                <div class="news-source mb-3">
                    نقلا عن الصفحة الرسمية لوزارة الاستثمار والتجارة الخارجية
                </div>

                <div class="news-body">
                    <p class="mb-4">
                        {{ newsItem.description }}
                    </p>
                </div>

            </div>


        </div>
    </div>
</div>

<div class="container text-center py-5" *ngIf="!newsItem">
    <h3>الخبر غير موجود</h3>
    <button class="btn btn-primary" routerLink="/medianews">العودة للأخبار</button>
</div>